import React from "react";
import {useTranslation} from "react-i18next";
import InputAdornment from "@mui/material/InputAdornment";
import MDInput from "../../../materialDashboard/components/MDInput";
import {preventValueChangeOnScroll} from "../../../utils/input";


const Model1MeasureField = ({name, formik, unitOfMeasure, warnings={}, ...props}) => {
    const {t} = useTranslation(['models1']);

    const changed = formik.values[name] !== formik.initialValues[name];

    return <MDInput name={name}
                    label={t(`model1Form.${name}`)}
                    value={formik.values[name]}
                    onChange={formik.handleChange}
                    error={formik.touched[name] && Boolean(formik.errors[name])}
                    helperText={(formik.touched[name] && formik.errors[name]) || (!changed && warnings[name])}
                    warning={!changed && Boolean(warnings[name])}
                    variant="standard"
                    fullWidth
                    onWheel={preventValueChangeOnScroll}
                    InputProps={{
                        endAdornment: <InputAdornment position="end" disableTypography>{unitOfMeasure}</InputAdornment>,
                    }}
                    {...props}/>
}

export default Model1MeasureField;